import {
  Directive,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
  inject
} from '@angular/core';
import { UserService } from 'taxtank-core';
import { UserRolesEnum } from 'taxtank-core/common';

/**
 * Shows content if current user's role matches the provided role
 * the implementation is very similar to *ngIf directive
 */
@Directive({
  selector: '[appRoles]',
  standalone: false
})
export class RolesDirective implements OnInit {
  @Input() appRoles: UserRolesEnum[] | UserRolesEnum;
  @Input() appRolesHierarchy = true;

  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private userService = inject(UserService);

  ngOnInit(): void {
    this.userService.getFirst().subscribe(user => {
      if (user.hasRoles(this.appRoles, this.appRolesHierarchy)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
